import React, { Fragment, Component } from "react";
import CartLineItem from "./CartLineItem";

class CartList extends Component {
  render() {
    const products = this.props.products;
    if (products == undefined || products.length < 1) {
      return (
        <div className="Loop Loop--minicart">
          <h5>Your Cart</h5>
          <hr />
          <div className="empty-loop">
            You don't have any items in your cart.
          </div>
        </div>
      );
    } else {
      return (
        <Fragment>
          <h5>Your Cart</h5>
          <hr></hr>
          <div className="Loop Loop--minicart">
            {products.map((product) => (
              <CartLineItem
                product={product}
                key={product.id}
                updateLineQuantity={this.props.updateLineQuantity}
              />
            ))}
          </div>
          <ul className="MiniCart__totals">
            {this.props.cart.total_discount > 0 && (
              <li>
                <span className="label">Discounts</span>
                <span className="discount">
                  ${(this.props.cart.total_discount / 100).toFixed(2)}
                </span>
              </li>
            )}
            <li className="subtotal">
              <span className="label">Subtotal</span>
              <span className="total">
                ${(this.props.cart.total_price / 100).toFixed(2)}
              </span>
            </li>
            <li className="notes">Free Shipping On Orders Over {this.props.freeShippingMininum}</li>
            <li className="cart-notes">
              <label htmlFor="note">Any Notes For Your Order?</label>
              <p>(e.g. Private well? Optimized for different address?)</p>
              <textarea
                rows="2"
                name="note"
                id="CartSpecialInstructions"
                defaultValue={this.props.cart.note}
                onChange={(e) => this.props.updateOrderNotes(e)}
              ></textarea>
            </li>
          </ul>

          <a
            className="Button checkout"
            name="checkout"
            data-style="solid primary"
            href="/checkout"
          >
            Checkout
          </a>
        </Fragment>
      );
    }
  }
}

export default CartList;
